<template>
  <div>
    <section class="section1">
      <div class="content" v-html="detail.strategy_content_cn">
        <!-- <div class="sCon">
          <div class="right">
            <div class="div">
              <p class="stitle">{{detail[0].strategy_title_cn}}</p>
              <div class="text">
                {{detail[0].strategy_content_cn}}
              </div>
            </div>
          </div>
          <div class="left">
            <img
              class="img"
              :src="detail[0].imgList[0]"
              alt=""
              srcset=""
            >
          </div>
        </div> -->
        <!-- <div class="sCon">
          <div class="left">
            <img
              class="img"
              :src="detail[1].imgList[0]"
              alt=""
              srcset=""
            >
          </div>
          <div class="right right1">
            <div class="div">
              <p class="stitle">{{detail[1].strategy_title_cn}}</p>
              <div class="text">
                {{detail[1].strategy_content_cn}}
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </section>
    <!-- <section class="section2">
      <img
        class="leftImg"
        :src="detail[2].imgList[0]"
        alt=""
      >
      <div class="rightDiv">
        <img
          class="rightImg"
          :src="detail[2].imgList[1]"
          alt=""
        >
        <img
          class="rightImg"
          :src="detail[2].imgList[1]"
          alt=""
        >
      </div>
    </section> -->
  </div>
</template>
<script>
import {Strategy} from '../../api/home'
export default {
  data(){
    return {
      detail:[{imgList:[]},{imgList:[]},{imgList:[]}]
    }
  },
  created(){
    Strategy({
      strategy_type:2
    }).then(res=>{
      // console.log(res.data)
      this.detail=res.data
    })
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";

.section1 {
  // width: px2Rem(1300px);
  margin: px2Rem(60px) auto;
  font-size: 0;
  .sCon {
    margin-top: px2Rem(60px);
    &:first-of-type {
      margin-top: 0;
    }
  }
  .right {
    position: relative;
    display: inline-block;
    width: px2Rem(630px);
    min-height: px2Rem(420px);
    margin-right: px2Rem(28px);
    vertical-align: top;
    .div {
      // position: absolute;
      width: 100%;
      top: 50%;
      // transform: translate(0, -50%);
      .stitle {
        margin-bottom: px2Rem(40px);
        font-size: px2Rem(40px);
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: left;
      }
      .text {
        font-size: px2Rem(24px);
        font-weight: 400;
        color: #606060;
        line-height: px2Rem(40px);
      }
    }
  }
  .left {
    display: inline-block;
    width: px2Rem(640px);
    .img {
      display: inline-block;
      width: 100%;
      height: px2Rem(420px);
      margin-bottom: px2Rem(20px);
      &:nth-of-type(2n-1) {
        margin-right: px2Rem(20px);
      }
    }
  }
  .right1 {
    margin-right: px2Rem(0px);
    margin-left: px2Rem(28px);
  }
}
.section2 {
  width: px2Rem(1300px);
  margin: 0 auto px2Rem(68px);
  font-size: 0;
  .leftImg {
    display: inline-block;
    width: px2Rem(800px);
    height: px2Rem(524px);
    margin-right: px2Rem(20px);
    vertical-align: top;
  }
  .rightDiv {
    display: inline-block;
    .rightImg {
      display: block;
      width: px2Rem(480px);
      height: px2Rem(252px);
      &:first-of-type {
        margin-bottom: px2Rem(20px);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolStrategy/Features.vue